export const GET_DRIVER_THRU_UID = "V3_GET_DRIVER_THRU_UID";
export const GET_DRIVERS = "V3_GET_DRIVERS";
export const CREATE_DRIVERS = 'V3_CREATE_DRIVERS'
export const CREATE_DRIVER = 'V3_CREATE_DRIVER'
export const UPDATE_DRIVER = 'V3_UPDATE_DRIVER'
export const GET_INCIDENT_REPORT_THRU_DRVIDS = 'V3_GET_INCIDENT_REPORT_THRU_DRVIDS'
export const GET_DRIVER_PERFORMANCE_DASHBOARD_DATA = 'V3_GET_DRIVER_PERFORMANCE_DASHBOARD_DATA'
export const CREATE_INCIDENT_REPORT = 'V3_CREATE_INCIDENT_REPORT'
export const UPDATE_INCIDENT_REPORT = 'V3_UPDATE_INCIDENT_REPORT'
export const CREATE_DRIVER_PRETRIP = 'V3_CREATE_DRIVER_PRETRIP'
export const GET_DRIVER_PRETRIP_RECORDS_BY_DRVID = 'V3_GET_DRIVER_PRETRIP_RECORDS_BY_DRVID'
export const GET_ALL_DRIVER_PRETRIP_CHECKLIST = 'V3_GET_DRIVER_PRETRIP_CHECKLIST'
export const SET_DRIVER_PRETRIP_FILTER = 'V3_SET_DRIVER_PRETRIP_FILTER'
export const SET_SCHEDULE_PRETRIP_SEARCH = 'V3_SET_SCHEDULE_PRETRIP_SEARCH'
export const CREATE_SCHEDULE_PRETRIP = 'V3_CREATE_SCHEDULE_PRETRIP'
// export const GET_DRIVER_PRETRIP_RECORDS_BY_DRVID = 'V3_GET_DRIVER_PRETRIP_RECORDS_BY_DRVID'